import { createFileRoute } from '@tanstack/react-router'

import { useGetClientMarket } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import { Card } from '@/components/card'
import Content from '@/components/content'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/table'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import MarketHeading from '../-components/marketHeading'
import MarketNavigation from '../-components/marketNavigation'

import InstrumentRow from './-components/instrumentRow'

export const Route = createFileRoute('/_authed/$client_code/markets/$market_code/instruments/')({
    component: InstrumentsConnectionsComponent,
})

function InstrumentsConnectionsComponent() {
    const { client_code, market_code } = Route.useParams()

    const { data: market } = useGetClientMarket(client_code, market_code, { query: { suspense: true } })

    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: {
                client_code,
            },
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code',
            params: {
                market_code,
                client_code,
            },
            text: market?.name || '--',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/instruments',
            params: {
                market_code,
                client_code,
            },
            text: 'Instruments',
        },
    ])

    if (!market) {
        return <UnexpectedDataStateError />
    }

    const instruments = market?.instruments.sort((a, b) => a.symbol.localeCompare(b.symbol))

    return (
        <>
            <MarketHeading market={market} />
            <Content>
                <MarketNavigation active="instruments" isTemplate={market.marketType === 'Template'} />
                <Card className="flex-grow">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Symbol</TableHead>
                                <TableHead>Name</TableHead>
                                <TableHead></TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {instruments &&
                                instruments.map(instrument => (
                                    <InstrumentRow
                                        key={instrument.id}
                                        marketCode={market_code}
                                        instrument={instrument}
                                    />
                                ))}
                        </TableBody>
                    </Table>
                </Card>
            </Content>
        </>
    )
}
